import { render, staticRenderFns } from "./content-menu.vue?vue&type=template&id=4087e0b2&"
import script from "./content-menu.vue?vue&type=script&lang=js&"
export * from "./content-menu.vue?vue&type=script&lang=js&"
import style0 from "./content-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-menu.vue"
export default component.exports